"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconButtonsFilled = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconButtonsFilled = function SvgIconButtonsFilled(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7081 5.20615C10.8885 5.02527 11 4.77566 11 4.5V1.5C11 0.947715 10.5523 0.5 10 0.5H2C1.44772 0.5 1 0.947715 1 1.5V4.5C1 4.77566 1.11154 5.02527 1.29195 5.20615C1.47299 5.38768 1.72338 5.5 2 5.5H10C10.2766 5.5 10.527 5.38768 10.7081 5.20615ZM10.7081 6.79385C10.527 6.61232 10.2766 6.5 10 6.5H2C1.72337 6.5 1.47299 6.61232 1.29195 6.79385C1.11154 6.97473 1 7.22434 1 7.5V10.5C1 11.0523 1.44772 11.5 2 11.5H10C10.5523 11.5 11 11.0523 11 10.5V7.5C11 7.22434 10.8885 6.97473 10.7081 6.79385Z",
    fill: "currentColor"
  }));
};

exports.SvgIconButtonsFilled = SvgIconButtonsFilled;